export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7355.fa04bf70.jpg";